import React from 'react';
import { Link } from 'react-router-dom';
import { Flex } from '@components';
import { Form, DatePicker, Input, InputNumber, Button, Select, Upload, Icon, TimePicker, Checkbox, Spin } from 'antd';
const Dragger = Upload.Dragger;
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "@utils/NHFetch";
import { message } from "antd/lib/index";
import moment from 'moment';
import NHSelect from "@components/common/NHSelect";
import { createUuid, getLoginUser } from '@utils/NHCore';
import NextButton from '@pages/SelfHelp/common/nextIndex'
// import 'moment/src/locale/zh-cn';
import createHistory from 'history/createHashHistory';
import CommonTip from "../common";
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import NHFormItem from "@components/common/NHFormItem";
const history = createHistory();
const format = 'HH:mm';


const basicUrl = "/zzbd";
const commonUrl = '/zzbdCommon';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

const formItemLayout1 = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};

@Form.create()
export default class Size extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD004',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                sfasbd: '',
                basbdyy: '',
                jtgj: '',
                ddz: '',
                dxsj: '',
                ptrs: 0
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            options: [],
            dqddz: '',
            nextUrl: '',//左侧菜单加载完后传进来
            search: '',
            operable: true,//是否显示环节
            nonOperationalData: {},//不可操作的数据
            bdqkHide: true,
            isHide: false,
            qtyy: true,
            asbdqk: '0',
            ddfs: '',
            sfxny: true,
            uploading: false,
            previewVisible: false,
            fileList: [],
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],  //可以导入的非图片格式
            cpList: [],
            cphsw: [],
            cphSnd: [],
            sjdList: [],
            fileList: [],
            dxrq: '',
            dxsjd: '',
            cphm1: '',
            cphm2: '',
            cphm3: '',
            cphm4: '',
            cphm5: '',
            cphm6: '',
            cphm7: '',
            cphm8: ''
        };
    }


    componentWillMount() {
        this.getDmkMc("YXWZ_LXJTGJ");
    }

    //渲染前获取信息
    componentDidMount() {
        let cphswList = ['京', '沪', '津', '渝', '鲁', '冀', '晋', '蒙', '辽', '吉', '黑', '苏', '浙', '皖', '闽', '赣', '豫', '湘', '鄂', '粤', '桂', '琼', '川', '贵', '云', '藏', '陕', '甘', '青', '宁', '新', '港', '澳', '台'];
        let cphSndwList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        let cpList1 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9','港','澳','学','领','警'];
        let sjd = ['00:00-06:00', '06:00-12:00', '12:00-18:00', '18:00-24:00']
        let cphsw = cphswList.map((item) => {
            return <Option key={item}>{item}</Option>
        });
        let cphSnd = cphSndwList.map((item) => {
            return <Option key={item}>{item}</Option>
        });
        let sjdList = sjd.map((item) => {
            return <Option key={item}>{item}</Option>
        });
        let cpList = cpList1.map((item) => {
            return <Option key={item}>{item}</Option>
        });
        this.setState({ cphsw: cphsw, cphSnd: cphSnd, sjdList: sjdList, cpList: cpList })
        this.queryQztjAndYlhj();
        this.getDdz();
        this.getQkpo();
        this.checkZzbdisLinked();
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                this.setState({ hjmc: hjmc })
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }


    //检查环节是否已办理
    checkZzbdisLinked = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let zzbdhjid = this.getUrlParams("pkid");

        NHFetch("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    if (res.data) {
                        this.setState({
                            editable: false,
                        });
                    } else {
                        this.setState({
                            editable: true
                        })
                    }
                }
            });
    };

    getQkpo() {
        const xsid = getLoginUser().userId;
        let lxjtgjmc = '';
        NHFetch(basicUrl + "/getQkpoByXsidAndNd", "GET", { xsid, xsid })
            .then(res => {
                if (res) {
                    if (res.data) {
                        let fileList = []
                        if (res.data.zmclid) {
                            fileList = [{
                                uid: res.data.zmclid,
                                name: res.data.zmclmc,
                                response: {
                                    data: {
                                        ssbh: res.data.zmclid,
                                        fjmc: res.data.zmclmc,
                                    }
                                },
                                status: 'done',
                                url: `anonymity/docrepo/download/file?attachmentId=${res.data.zmclid}`
                            }];
                        }

                        this.state.lxjtgjmcList.map(initItem => {
                            if (initItem.DM === res.data.jtgj) {
                                lxjtgjmc = initItem.MC;
                            }
                        });
                        let cphm1 = '';
                        let cphm2 = '';
                        let cphm3 = '';
                        let cphm4 = '';
                        let cphm5 = '';
                        let cphm6 = '';
                        let cphm7 = '';
                        let cphm8 = '';
                        let sfxny = this.state.sfxny;
                        if (res.data.cphm) {
                            cphm1 = res.data.cphm.substring(0, 1)
                            cphm2 = res.data.cphm.substring(1, 2)
                            cphm3 = res.data.cphm.substring(2, 3)
                            cphm4 = res.data.cphm.substring(3, 4)
                            cphm5 = res.data.cphm.substring(4, 5)
                            cphm6 = res.data.cphm.substring(5, 6)
                            cphm7 = res.data.cphm.substring(6, 7)
                            if (res.data.cphm.length > 7) {
                                cphm8 = res.data.cphm.substring(7, 8)
                            }
                            sfxny = res.data.cphm.length == 7 ? true : false

                        }
                        this.setState({
                            initPOvalue: res.data,
                            fileList: fileList,
                            dxrq: res.data.dxsj && res.data.dxsj.split("  ")[0] ? res.data.dxsj.split("  ")[0] : '',
                            dxsjd: res.data.dxsj && res.data.dxsj.split("  ")[1] ? res.data.dxsj.split("  ")[1] : '',
                            update: true,
                            lxjtgjmc: lxjtgjmc,
                            bdqkHide: res.data.sfbd == '1' ? false : true,
                            isHide: res.data.sfasbd == '0' ? false : true,
                            asbdqk: res.data.sfasbd,
                            qtyy: res.data.basbdyy == '99' ? false : true,
                            sfxny: sfxny,
                            ddfs: res.data.jtgj,
                            cphm1: cphm1,
                            cphm2: cphm2,
                            cphm3: cphm3,
                            cphm4: cphm4,
                            cphm5: cphm5,
                            cphm6: cphm6,
                            cphm7: cphm7,
                            cphm8: cphm8,
                        });
                        let dqddz = this.state.initPOvalue.ddz;
                        if(res.data.jtgj){
                           this.state.ddz.length>0&&this.DdzSeleOption(res.data.jtgj);
                        }

                        this.setState({
                            dqddz: dqddz
                        });


                    }
                }
            });
    }


    handleSubmit = e => {

        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            // if (values['sfasbd'] == '0') {
            //     if (values['basbdyy'] == null || typeof (values['basbdyy']) == "undefined" || values['basbdyy'].trim().length == 0) {
            //         message.error('不按时到达请填写原因。');
            //         return
            //     }
            // }

            const clzm = values['clzm'];
            let zmclid = '';
            let zmclmc = ''
            if (clzm) {
                if (clzm['fileList'] && clzm['fileList'].length > 0) {
                    let fileList = clzm['fileList'];
                    zmclid = fileList[0].response.data.ssbh;
                    zmclmc = fileList[0].name;
                }
            }
            values['zmclid'] = zmclid;
            values['zmclmc'] = zmclmc;

            let sUrl = '/saveBdqkData';
            if (this.state.update) {
                sUrl = '/updateBdqkData';
            }
            // //修改 可编辑状态，并可以update数据
            if (!this.state.editable) {
                this.setState({ update: true, editable: true });
                return
            }

            const { dxrq, cphm1, cphm2, cphm3, cphm4, cphm5, cphm6, cphm7 } = values;
            let dxsj1 = moment(dxrq).format("YYYY-MM-DD");
            let dxsj2 = values['dxsjd']
            let dxsj = dxsj1 + '  ' + dxsj2;
            values.dxsj = dxsj;

            let cphm = cphm1 + cphm2 + cphm3 + cphm4 + cphm5 + cphm6 + cphm7;
            if (values.cphm8) {
                cphm = cphm + values.cphm8
            }
            values.cphm = cphm;
            values.sfasbd = '0';
            const xsid = getLoginUser().userId;
            const zzbdhjid = this.getUrlParams("pkid");
            let params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };

            // //请求保存或修改数据
            NHFetch(basicUrl + sUrl, 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('信息保存成功！');
                            this.reloadMenu();
                            this.getQkpo();
                        } else {
                            message.error('信息保存失败，请重试！');
                        }
                    }
                })
        });
    };

    //获取url中传递的参数
    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };


    //获取下拉列表value对应的名称
    getDmkMc = (dmbz) => {
        NHFetch(basicUrl + "/getDmkMc", "GET", { dmbz, dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_LXJTGJ") {
                            this.setState({ lxjtgjmcList: res.data });
                        }
                    }
                }
            });
    }
    //获取到达站下拉列表的名称
    getDdz = () => {
        NHFetch(basicUrl + "/getDdz", "GET")
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.setState({ ddz: res.data });
                    }
                }
            });
    }

    //到达站级联
    DdzSeleOption = (value) => {
        let dqddz = this.state.initPOvalue.ddz;

        let coptions = this.state.ddz && this.state.ddz.length > 0 && this.state.ddz.map((item, key) => {
            if (value === item.ZTLX) {
                dqddz = dqddz?dqddz:item.ZTMC;
                return <Option key={item.ZTMC}>{item.ZTMC}</Option>
            } else {
                return null
            }
        });
        this.props.form.setFieldsValue({ ddz: dqddz });
        this.setState({ options: coptions, dqddz: dqddz, ddfs: value });
    }


    //下拉框发生变化检测
    onChange = (value) => {
        this.DdzSeleOption(value);
    }

    //修改是否报到状态
    onSfbdChange = (value) => {
        this.setState({ bdqkHide: value == '1' ? false : true });
    }

    // //动态显示报到情况填写
    // onSfasbdChange = (value) => {
    //     this.setState({ asbdqk: value, isHide: value == '0' ? false : true });
    // }

    //动态显示报到情况填写
    onWbdyyChange = (value) => {
        this.setState({ qtyy: value == '99' ? false : true });
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    changeQclx = (e) => {
        this.setState({ sfxny: !e.target.checked });

    }


    // 转化base64
    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    // 点击文件链接或预览图标时的回调
    handlePreview = file => {
        const isImage = /^image\/.*$/i.test(file.type);
        if (isImage) {
            if (file) {
                this.getBase64(file, imageUrl => {
                    this.setState({
                        previewImage: imageUrl,
                        previewVisible: true
                    });
                });
            } else {
                this.setState({
                    previewImage: file.url || file.thumbUrl,
                    previewVisible: true
                });
            }
        } else if (file && file['response'] && file['response']['data']) {//其他情况
            let isImage = true;
            let fjmc = file['response']['data']['fjmc'];
            let ssbh = file['response']['data']['ssbh'];
            if (
                !this.setJudge(fjmc, this.state.judgeImgList)
            ) {
                isImage = false;
            }

            if (isImage) {
                this.showPreview(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            } else {
                window.open(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            }
        }
    };

    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }

    handleChange = ({ file, fileList }) => {
        let count = 0;
        fileList.map((elem) => {
            if (elem && elem['status'] && elem['status'] === 'uploading') {
                this.setState({ uploading: true });
                return;
            } else if (elem && elem['status']) {
                count++;
            }
        })
        if (count > 0) {
            this.setState({ uploading: false });
        }
        this.setState({ fileList: file.status ? [...fileList] : this.state.fileList });
    }


    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }

    beforeUpload = (file) => {
        if (
            !(this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList))
        ) {
            message.error('不能上传该格式文件');
            return false;
        }
        else if (this.state.fileList.length > 0) {
            message.error('只能上传一个文件');
            return false;
        }
        else {
            return true;
        }
    }

    remove = (ssbh) => {
        let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url, "POST").then(res => {
            if (res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const { editable, initPOvalue, lxjtgjmc, options, dqddz, isHide, bdqkHide, cpList, qtyy, asbdqk, ddfs, sfxny, cphsw, cphSnd, sjdList, cphm1, cphm2, cphm3, cphm4, cphm5, cphm6, cphm7, cphm8 } = this.state;
        const props = {
            name: 'file',
            action: 'anonymity/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },

            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    this.props.form.setFieldsValue({ clzm: { fileList: newFileList } });
                    return {
                        fileList: newFileList
                    };
                }, () => {
                    if (file.response && file.response.data && file.response.data.ssbh) {
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if (!this.beforeUpload(file)) {
                    return false;
                }
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file]
                }));
                return true;
            },
            onChange: file => { this.handleChange(file) },
            onPreview: this.handlePreview,
            fileList: this.state.fileList,
        };
        return (
            <div>{this.state.operable ?
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref={"siderMenu"}
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        /* active={3}*/
                        mkbz={this.state.mkbz}
                        menuType='自助报到'
                    />
                    <Flex.Item className="page_con_r" styleName="">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: this.state.hjmc }
                            ]}
                        />
                        <div className="box">
                            <Hint />
                            <TitleTop title={this.state.hjmc} extra={false} />
                            <Form onSubmit={this.handleSubmit}>
                                <div className="p-sw">
                                    <Flex align="start" wrap="wrap">
                                        <div className="form_item">
                                            <FormItem
                                                {...formItemLayout}
                                                label="是否报到入学"
                                            >
                                                {getFieldDecorator('sfbd', {
                                                    initialValue: initPOvalue.sfbd, placeholder: '请选择',
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                '请选择是否报到入学'
                                                        }
                                                    ]
                                                })(
                                                    editable ?
                                                        <Select placeholder="请选择" onChange={this.onSfbdChange}>
                                                            <Option value="1">
                                                                是
                                                            </Option>
                                                            <Option value="0">
                                                                否
                                                        </Option>
                                                        </Select> : <span>{initPOvalue.sfbd == 1 ? '是' : '否'}</span>
                                                )}
                                            </FormItem>
                                        </div>

                                        {/* {!bdqkHide &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="是否按时报到"
                                                >
                                                    {getFieldDecorator('sfasbd', {
                                                        initialValue: initPOvalue.sfasbd, placeholder: '请选择',
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    '请选择是否按时报到'
                                                            }
                                                        ]
                                                    })(
                                                        editable ?
                                                            <Select placeholder="请选择" onChange={this.onSfasbdChange}>
                                                                <Option value="0">
                                                                    按时报到
                                                                </Option>
                                                                <Option value="1">
                                                                    因特殊情况提前到校
                                                                </Option>
                                                                <Option value="2">
                                                                    因特殊情况推迟到校
                                                                </Option>
                                                            </Select> : <span>{initPOvalue.sfasbd == 0 ? '按时报到' : (initPOvalue.sfasbd == 1 ? '因特殊情况提前到校' : '因特殊情况推迟到校')}</span>
                                                    )}
                                                </FormItem>
                                            </div>} */}
                                        {!bdqkHide && asbdqk == 1 &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="提前原因"
                                                >
                                                    {getFieldDecorator('tqtcyy', { initialValue: initPOvalue.tqtcyy })(
                                                        editable ? <Input placeholder="请填写原因" /> :
                                                            <span>{initPOvalue.tqtcyy}</span>
                                                    )}
                                                </FormItem>
                                            </div>
                                        }
                                        {!bdqkHide && asbdqk == 2 &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="推迟原因"
                                                >
                                                    {getFieldDecorator('tqtcyy', { initialValue: initPOvalue.tqtcyy })(
                                                        editable ? <Input placeholder="请填写原因" /> :
                                                            <span>{initPOvalue.tqtcyy}</span>
                                                    )}
                                                </FormItem>
                                            </div>
                                        }
                                        {!bdqkHide && asbdqk == 1 || asbdqk == 2 ? <div className="form_item">
                                            <FormItem
                                                {...formItemLayout}
                                                label="是否已跟学校联系"
                                            >
                                                {getFieldDecorator('sflxxx', {
                                                    initialValue: initPOvalue.sflxxx, placeholder: '请选择',
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                '是否已跟学校联系'
                                                        }
                                                    ]
                                                })(
                                                    editable ?
                                                        <Select placeholder="请选择" >
                                                            <Option value="1">
                                                                是
                                                        </Option>
                                                            <Option value="0">
                                                                否
                                                        </Option>
                                                        </Select> : <span>{initPOvalue.sflxxx == 1 ? '是' : '否'}</span>
                                                )}
                                            </FormItem>
                                        </div> : ''}
                                        {!bdqkHide && asbdqk == 1 || asbdqk == 2 ? <div className="form_item" >
                                            <FormItem
                                                {...formItemLayout}
                                                label="材料证明"
                                            >
                                                {getFieldDecorator('clzm', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message:
                                                                '请上传材料证明'
                                                        }
                                                    ]
                                                })(
                                                    <Dragger {...props}>
                                                        <p className="ant-upload-drag-icon">
                                                            <Icon type="inbox" />
                                                        </p>
                                                        <Spin spinning={this.state.uploading} />
                                                        <p className="ant-upload-text font-14">
                                                            点击此处或拖拽文件到此
                                                    </p>
                                                    </Dragger>
                                                )}
                                            </FormItem>
                                        </div> : ''}


                                        {bdqkHide &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="不报到原因"
                                                >
                                                    {getFieldDecorator('basbdyy', {
                                                        initialValue: initPOvalue.basbdyy,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    '请选择不报到原因'
                                                            }
                                                        ]
                                                    })(
                                                        editable ?

                                                            <NHSelect sign={"DMK_YXXT_WBDYY"} onChange={this.onWbdyyChange} />

                                                            : <span>{}</span>
                                                    )}
                                                </FormItem>
                                            </div>}

                                        {!qtyy && bdqkHide &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="其他不报到原因"
                                                >
                                                    {getFieldDecorator('qtbasbdyy', { initialValue: initPOvalue.qtbasbdyy })(
                                                        editable ? <Input placeholder="请填写原因" /> :
                                                            <span>{initPOvalue.qtbasbdyy}</span>
                                                    )}
                                                </FormItem>
                                            </div>
                                        }

                                        {!bdqkHide && !isHide &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="来校交通工具"
                                                >
                                                    {getFieldDecorator('jtgj', {
                                                        initialValue: initPOvalue.jtgj,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    '请选择来校交通工具'
                                                            }
                                                        ]
                                                    })(
                                                        editable ?

                                                            <NHSelect sign={"dmk_yxwz_lxjtgj"} onChange={(v) => {
                                                                this.onChange(v);
                                                            }} />

                                                            : <span>{lxjtgjmc}</span>
                                                    )}
                                                </FormItem>
                                            </div>
                                        }
                                        {!bdqkHide && !isHide &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="到达站"
                                                >
                                                    {getFieldDecorator('ddz', {
                                                        initialValue: initPOvalue.ddz,
                                                        rules: [
                                                            {
                                                                message:
                                                                    '请选择到达站'
                                                            }
                                                        ]
                                                    })(
                                                        editable ? (ddfs == '05' ? <Input /> : <Select >
                                                            {options}
                                                        </Select>)



                                                            : <span>{dqddz}</span>
                                                    )}
                                                </FormItem>
                                            </div>
                                        }

                                        {!bdqkHide && !isHide &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label={
                                                        <span>
                                                          <span style={{ color: 'red' }}>*</span>到校日期&nbsp;
                                                        </span>
                                                      }
                                                >
                                                    {getFieldDecorator('dxsj', {

                                                        rules: [
                                                            {
                                                                // required: true,
                                                                // required: editable,
                                                                message:
                                                                    '请选择到校日期'
                                                            }
                                                        ]
                                                    })(
                                                        editable ?
                                                            <Input.Group compact onChange={this.Changesj}>
                                                                <FormItem className="dxrq" style={{ 'width': '60%' }}
                                                                // {...formItemLayout}
                                                                >
                                                                    {getFieldDecorator('dxrq', {
                                                                        initialValue: this.state.dxrq == '' ? null : moment(this.state.dxrq, 'YYYY-MM-DD'), rules: [
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    '请选择到校日期'
                                                                            }
                                                                        ]
                                                                    })(
                                                                        <DatePicker
                                                                            // style={{ 'minwidth': '90%' }}
                                                                            showTime
                                                                            format="YYYY-MM-DD"
                                                                        />
                                                                    )}
                                                                </FormItem>

                                                                <FormItem style={{ 'width': '36%', float: "right" }} id="dxsjd"
                                                                // {...formItemLayout}
                                                                >
                                                                    {getFieldDecorator('dxsjd', {
                                                                        initialValue: this.state.dxsjd, rules: [
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    '请选择到校时间段'
                                                                            }
                                                                        ]
                                                                    })(
                                                                        <Select
                                                                            style={{ 'width': '100%' }}
                                                                        >{sjdList}</Select>)}
                                                                    <style jsx="true" global="true">
                                                                        {`
                                                                    #dxrq.ant-col-16 {
                                                                        display: block;
                                                                        box-sizing: border-box;
                                                                        width: 66.66666667%;
                                                                        float: right;
                                                                    }
                                                                `}
                                                                    </style>
                                                                </FormItem>
                                                            </Input.Group>
                                                            : <span>{initPOvalue.dxsj}</span>
                                                    )}

                                                </FormItem>
                                            </div>
                                        }
                                        {!bdqkHide && !isHide &&
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="陪同人数"
                                                >
                                                    {getFieldDecorator('ptrs', { initialValue: initPOvalue.ptrs, rules: [
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    '请填写陪同人数'
                                                                            }
                                                                        ] })(
                                                        editable ?
                                                            <InputNumber
                                                                precision={0}
                                                                min={0}
                                                                max={10}
                                                            /> : <span>{initPOvalue.ptrs}</span>
                                                    )}&nbsp;&nbsp;<span>  (人) </span>
                                                </FormItem>
                                            </div>
                                        }
                                        {!bdqkHide && !isHide && ddfs == '04' &&
                                            <div className="form_item" style={{ width: '75%' }}>
                                                <FormItem
                                                    label="车牌号码"
                                                    {...formItemLayout1}
                                                >
                                                    {getFieldDecorator('cphm', { initialValue: initPOvalue.cphm })(
                                                        editable ? <Input.Group compact>
                                                            <FormItem className="cphm" style={{ width: '13%' }}
                                                            >
                                                                {getFieldDecorator('cphm1', {
                                                                    initialValue: cphm1, rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写正确的车牌号'
                                                                        }
                                                                    ]
                                                                })(
                                                                    <Select showSearch
                                                                        optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                        {cphsw}
                                                                    </Select>)}
                                                            </FormItem>
                                                            <FormItem style={{ width: '12.5%' }}
                                                            >
                                                                {getFieldDecorator('cphm2', {
                                                                    initialValue: cphm2, rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写正确的车牌号'
                                                                        }
                                                                    ]
                                                                })(
                                                                    <Select showSearch
                                                                        optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                        {cphSnd}
                                                                    </Select>)}
                                                            </FormItem>
                                                            <FormItem style={{ width: '12.5%' }}
                                                            >
                                                                {getFieldDecorator('cphm3', {
                                                                    initialValue: cphm3, rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写正确的车牌号'
                                                                        }
                                                                    ]
                                                                })(
                                                                    <Select showSearch
                                                                        optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                        {cpList}
                                                                    </Select>)}
                                                            </FormItem>
                                                            <FormItem style={{ width: '12.5%' }}
                                                            >
                                                                {getFieldDecorator('cphm4', {
                                                                    initialValue: cphm4, rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写正确的车牌号'
                                                                        }
                                                                    ]
                                                                })(
                                                                    <Select showSearch
                                                                        optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                        {cpList}
                                                                    </Select>)}
                                                            </FormItem>
                                                            <FormItem style={{ width: '12.5%' }}
                                                            >
                                                                {getFieldDecorator('cphm5', {
                                                                    initialValue: cphm5, rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写正确的车牌号'
                                                                        }
                                                                    ]
                                                                })(
                                                                    <Select showSearch
                                                                        optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                        {cpList}
                                                                    </Select>)}
                                                            </FormItem>
                                                            <FormItem style={{ width: '12.5%' }}
                                                            >
                                                                {getFieldDecorator('cphm6', {
                                                                    initialValue: cphm6, rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写正确的车牌号'
                                                                        }
                                                                    ]
                                                                })(
                                                                    <Select showSearch
                                                                        optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                        {cpList}
                                                                    </Select>)}
                                                            </FormItem>
                                                            <FormItem style={{ width: '12.5%' }}
                                                            >
                                                                {getFieldDecorator('cphm7', {
                                                                    initialValue: cphm7, rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写正确的车牌号'
                                                                        }
                                                                    ]
                                                                })(
                                                                    <Select showSearch
                                                                        optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                        {cpList}
                                                                    </Select>)}
                                                            </FormItem>
                                                            {!sfxny &&
                                                                <FormItem style={{ width: '12.5%' }}
                                                                >
                                                                    {getFieldDecorator('cphm8', {
                                                                        initialValue: cphm8, rules: [
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    '请填写正确的车牌号'
                                                                            }
                                                                        ]
                                                                    })(
                                                                        <Select showSearch
                                                                            optionFilterProp="children" style={{ 'width': '100%' }}>
                                                                            {cpList}
                                                                        </Select>)}
                                                                </FormItem>}

                                                            {/* <FormItem style={{ 'width': '50%' }}
                                                            // {...formItemLayout}
                                                            >
                                                                {getFieldDecorator('cphm3', {
                                                                    initialValue: cphm3,
                                                                    rules: [
                                                                        {
                                                                            pattern: sfxny ? /^[a-z0-9A-Z]{5}$/ : /^[a-z0-9A-Z]{6}$/, message: '车牌号格式输入错误',
                                                                        }
                                                                    ]
                                                                }
                                                                )(

                                                                    <Input style={{ 'width': '100%' }} />)}
                                                            </FormItem> */}
                                                        </Input.Group> :
                                                            <span>{initPOvalue.cphm}</span>
                                                    )}

                                                </FormItem>

                                            </div>

                                        }
                                        {editable && !bdqkHide && !isHide && ddfs == '04' &&
                                            <div className="form_item" style={{ width: '20%', paddingLeft: '20px', marginTop: '1.8%' }}>
                                                <Checkbox defaultChecked={!sfxny} onChange={this.changeQclx}>新能源</Checkbox>
                                            </div>
                                        }

                                    </Flex>
                                    <div className="text-center mt-50">
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            {editable ? '保存' : '修改'}
                                        </Button>
                                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </Flex.Item>
                </Flex>
                : <CommonTip hjmc={"报到情况填写"} key={'GD004'} mkbz='GD004' nonOperationalData={this.state.nonOperationalData} />}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/SelfHelp/report/index.js